import { makeGetRequest } from 'owa-ows-gateway/lib/lazyIndex';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Performs a request to the Places API to fetch all cities
 */
export default function getCities(): Promise<Response> {
    const endpoint: string = isFeatureEnabled('cal-mf-placesb2')
        ? 'LocationsB2/odata/api/v1.0/Localities/Places.GetCities'
        : 'Locations/odata/api/v1.0/Localities/Places.GetCities';

    return makeGetRequest(endpoint, undefined, true, undefined, undefined, undefined, 'cities');
}
